/**
 * usersMe actions
 */
import {
    USERS_ME_SET,
    USERS_ME_LOAD_REQUESTED,
    USERS_ME_LOAD_SUCCEEDED,
    USERS_ME_LOAD_FAILED,
    USERS_ME_UPDATE_REQUESTED,
    USERS_ME_UPDATE_SUCCEEDED,
    USERS_ME_UPDATE_FAILED
} from './constants';

export function setUsersMe(data: Record<string, any>) {
    return {
        type: USERS_ME_SET,
        payload: data
    };
}

export function loadUsersMe() {
    return {
        type: USERS_ME_LOAD_REQUESTED,
        meta: {
            logentries: true
        }
    };
}

export function usersMeLoaded(response: Record<string, any>) {
    return {
        type: USERS_ME_LOAD_SUCCEEDED,
        payload: response
    };
}

export function usersMeLoadingError(error: Error) {
    return {
        type: USERS_ME_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function updateUsersMe(data: Record<string, any>) {
    return {
        type: USERS_ME_UPDATE_REQUESTED,
        payload: data,
        meta: {
            logentries: true
        }
    };
}

export function updateUsersMeSucceeded(response: Record<string, any>) {
    return {
        type: USERS_ME_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function updateUsersMeFailed(error: Error) {
    return {
        type: USERS_ME_UPDATE_FAILED,
        payload: error,
        error: true
    };
}
